<div class="page">

    <div class="k-d-flex k-d-flex-row k-mb-3">
        <h5>{{ 'EditTimeOffInLieuType' | translate: {Default: "Edit Time Off in Lieu Type"} }}</h5>
        <div class="k-flex-grow"></div>
        <div class="buttons-container">
            <button mat-raised-button  appPreventDoubleClick (throttledClick)="cancel()" class="k-mr-2">{{ 'Cancel' | translate: {Default: "Cancel"} }}</button>
            <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="saveForm()" class="k-mr-4" [disabled]="!form?.valid">{{ 'SaveForm' | translate: {Default: "Save Form"} }}</button>
            <button mat-raised-button color="warn" appPreventDoubleClick (throttledClick)="showDeleteTypeConfirmation()">
                <span class="material-icons-outlined">delete</span>
                {{ 'DeleteType' | translate: {Default: "Delete Type"} }}
            </button>
        </div>
    </div>
    
    <div class="form-section-title">
    </div>
    
    <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white; width:100%">
        <mat-spinner></mat-spinner>
    </div>
    
    <div class="form" [formGroup]="form" *ngIf="!isLoading">
    
        <app-localization-text-form-field
            [formElement]="{ formControl: 'localizations', localizationValueParam: 'text', text: ('TimeOffInLieuName' | translate: {Default: 'Time Off In Lieu Name'}), disabled: 'false' }"
            [parentGroup]="form"
            [cultures]="cultures"
            (emitAddtoFormArray)="addNewLocalization()"
            (emitDeleteFromFormArray)="deleteLocalization($event.index)"
        ></app-localization-text-form-field>

        <div class="form-section-title">
            <h6>
                {{ 'TimeOffInLieuIcon' | translate: {Default: "Time Off In Lieu Icon"} }}
            </h6>
    
        </div>
        <div class="k-mb-3">
            <div *ngIf="filePath && filePath !== ''; else noImage">
                <img [src]="domSanitizer.bypassSecurityTrustUrl(filePath)" class="timeoff-type-icon" [alt]="'ToilTypeIcon' | translate: {Default: 'Time off in lieu type icon'}">
            </div>
            <ng-template #noImage>
                <div class="no-image"></div>
            </ng-template>
        </div>
    
        <div class="k-mb-3">
            <button type="button" mat-raised-button appPreventDoubleClick (throttledClick)="fileInput.click()">{{ 'ChooseFile' | translate: {Default: "Choose File"} }}</button>
            <input hidden type="file" accept="image/*" #fileInput (change)="imagePreview($event)"/>
        </div>
    
    </div>
</div>    

